import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAmbulanceIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M10 11.75H6M9.25 4L9.75 2.75H10.25L10.75 4M3 11.75H1.75V4.25H10.25M13 11.75H14.25V8.25M10.25 4.25H11.5L14.25 7.5V8.25M10.25 4.25V8.25H14.25" }),
		/* @__PURE__ */ _jsx("path", { d: "M6.25 6.5V9M5 7.75H7.5" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 4.5,
			cy: 12,
			r: 1.25
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11.5,
			cy: 12,
			r: 1.25
		})
	]
});
export default SvgAmbulanceIcon;
